import * as _ from 'lodash';
import { CertificateSettingsContext, CustomerSettingsContext } from '../..';

// eslint-disable-next-line import/prefer-default-export
export function settingContextObjectLookup(
  settingsContext: CertificateSettingsContext | CustomerSettingsContext,
  index: number,
  settingCustomField: string,
  customColumnPrefix: string,
): string {
  const columnName = `${customColumnPrefix}${index}`;
  const translatedColumn = columnName.replace(customColumnPrefix, settingCustomField).replace(' ', '');

  return settingsContext ? settingsContext[translatedColumn] as string : columnName;
}
